// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3U2XD","rootSuccess":"CompleteLink_rootSuccess__1IWzI","rootFailure":"CompleteLink_rootFailure__1m3CT","isDisabled":"CompleteLink_isDisabled__1Q1zy"};